<div class="pedido-filter">
  <div class="pedido-filter__dates">
    <sgt-pedido-referencia-data-select
      [referencias]="referenciasData"
      [(ngModel)]="filter.referenciaData"
      (idReferenciaChange)="onChangeReferenciaData($event)">
    </sgt-pedido-referencia-data-select>

    <sgt-novo-datepicker
      [(ngModel)]="vigenciaValue"
      [withNavigation]="true"
      (dateChange)="onDateChange($event)">
    </sgt-novo-datepicker>
  </div>

  <div class="pedido-filter__row" [class.pedido-filter__row--mobile]="isMobile">
    <div class="pedido-filter__selects" [class.pedido-filter__selects--mobile]="isMobile">
      <sgt-novo-pedido-status-multi-select
        [(ngModel)]="filter.status"
        variante="filtro"
        (idsPedidoStatusChange)="onStatusChange($event)"
      ></sgt-novo-pedido-status-multi-select>

      <sgt-novo-config-pedido-tipo-venda-multi-select
        [(ngModel)]="filter.tiposVendas"
        variante="filtro"
        (tiposVendasChange)="onTiposVendasChange($event)"
      ></sgt-novo-config-pedido-tipo-venda-multi-select>

      <sgt-novo-representante-multi-select
        *ngIf="isShowRepresentantesFilter && !isRepresentante"
        [(ngModel)]="filter.idsRepresentantes"
        variante="filtro"
        (search)="onRepresentantesChange($event)"
      ></sgt-novo-representante-multi-select>

      <sgt-segmentos-multi-select
        [(ngModel)]="filter.idsClassificacoesClientes"
        [segmento]="tipoSegmento.CLIENTE"
        [settings]="{
          placeholder: 'Segmentos de Cliente',
          singular: 'Segmento de Cliente',
          plural: 'Segmentos de Cliente',
          searchEmptyResultMessage: 'Nenhum segmento de cliente encontrado'
        }"
        variante="filtro"
        (changed)="onSegmentosClientesChange($event)"
      ></sgt-segmentos-multi-select>

      <sgt-segmentos-multi-select
        [(ngModel)]="filter.idsClassificacoesItens"
        [segmento]="tipoSegmento.ITEM"
        [settings]="{
          placeholder: 'Segmentos de Item',
          singular: 'Segmento de Item',
          plural: 'Segmentos de Item',
          searchEmptyResultMessage: 'Nenhum segmento de item encontrado'
        }"
        variante="filtro"
        (changed)="onSegmentosItensChange($event)"
      ></sgt-segmentos-multi-select>
    </div>

    <div class="pedido-filter__actions">
      <button
        type="button"
        class="btn btn-light"
        (click)="refresh()"
        sgtTooltip="Atualizar listagem"
        aria-label="Atualizar listagem"
      >
        <i class="fas fa-sync-alt" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="btn btn-light pedido-filter__btn-filtros"
        (click)="openFilterModal()"
        sgtTooltip="Filtros avançados"
        aria-label="Filtros avançados"
      >
        <i class="fas fa-filter" aria-hidden="true"></i>
        <span *ngIf="filterCount > 0" class="badge badge-primary ml-1">{{ filterCount }}</span>
      </button>
    </div>
  </div>
</div>

<sgt-modal
  [isOpen]="isFilterModalOpen"
  [settings]="filterModalSettings"
  (closed)="onCloseFilterModal()"
>
  <div header>
    <h5 class="modal__title mb-0">
      <i class="fas fa-sliders-h mr-2 mb-0"></i> Filtros Avançados
    </h5>
  </div>

  <div body>
    <div class="filter-sidebar">
      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-hashtag"></i> Identificação do Pedido
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-6">
              <label for="filterNumero" class="col-form-label">Número</label>
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="filter.numero"
                id="filterNumero"
                sgtNumbersOnly
                placeholder="Núm. Sogivendas"
              />
            </div>
            <div class="form-group col-6">
              <label for="numeroEcommerce" class="col-form-label">Número E-commerce</label>
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="filter.numeroEcommerce"
                id="numeroEcommerce"
                placeholder="Núm. E-commerce"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="filterNumeroErp" class="col-form-label">Número ERP</label>
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="filter.numeroErp"
                id="filterNumeroErp"
                placeholder="Núm. ERP"
              />
            </div>
            <div class="form-group col-6">
              <label for="numeroCanalVenda" class="col-form-label">Número Canal de Venda</label>
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="filter.numeroCanalVenda"
                id="numeroCanalVenda"
                placeholder="Núm. Canal de Venda"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-user-shield"></i> Acessos
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Gerentes</label>
              <sgt-usuario-multi-select
                [(ngModel)]="filter.idsGerentes"
                [perfil]="EnumUsuarioPerfil.GERENTE"
                [situacao]="EnumSituacao.ATIVO"
                [settings]="{
                  placeholder: 'Selecione os gerentes',
                  singular: 'Gerente',
                  plural: 'Gerentes',
                  showFooter: false
                }"
              >
              </sgt-usuario-multi-select>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Atendentes</label>
              <sgt-usuario-multi-select
                [(ngModel)]="filter.idsAtendentes"
                [perfil]="EnumUsuarioPerfil.ATENDENTE"
                [situacao]="EnumSituacao.ATIVO"
                [settings]="{
                  placeholder: 'Selecione os atendentes',
                  singular: 'Atendente',
                  plural: 'Atendentes',
                  showFooter: false
                }"
              >
              </sgt-usuario-multi-select>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-section" *ngIf="isShowClienteFilter">
        <h6 class="filter-section__title">
          <i class="fas fa-user"></i> Cliente
        </h6>
        <div class="filter-section__content">
          <div class="row mb-3">
            <div class="form-group col-12">
              <label for="filterCliente" class="col-form-label">Cliente</label>
              <sgt-novo-typeahead-cliente-pessoa
                [(ngModel)]="filter.pessoa"
                id="filterCliente"
              ></sgt-novo-typeahead-cliente-pessoa>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Classificações {{ KPI_RAP.sigla }}</label>
              <sgt-novo-classificacao-faturamento-multiselect
                [(ngModel)]="filter.idsClassificacoesFaturamentosPretendidas"
              ></sgt-novo-classificacao-faturamento-multiselect>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">{{ KPI_CUSTOMER_SHARE.nome }} {{ KPI_RAP.sigla }}</label>
              <sgt-novo-customer-share-indicador-multiselect
                [(ngModel)]="filter.indicadoresCustomersSharesPretendidos"
              ></sgt-novo-customer-share-indicador-multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-section" *ngIf="configPedido?.exibirSetorGep || config.canShowGruposRentabilidadeMultiselect">
        <h6 class="filter-section__title">
          <i class="fas fa-clipboard-list"></i> Gestão do Pedido
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12" *ngIf="configPedido?.exibirSetorGep">
              <label class="col-form-label">Setores GEP</label>
              <sgt-novo-pedido-setor-gep-multiselect
                [(ngModel)]="filter.setoresGep">
              </sgt-novo-pedido-setor-gep-multiselect>
            </div>
            <div class="form-group col-12" *ngIf="config.canShowGruposRentabilidadeMultiselect">
              <label class="col-form-label">Grupos de Rentabilidade</label>
              <sgt-escala-rentabilidade-multi-select
                [(ngModel)]="filter.idsGruposRentabilidade"
                [settings]="{ showFooter: false }">
              </sgt-escala-rentabilidade-multi-select>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-star-of-life"></i> Origem
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Plataformas de Origem</label>
              <sgt-novo-origem-lancamento-cadastro-multiselect
                [(ngModel)]="filter.origensLancamentos"
              ></sgt-novo-origem-lancamento-cadastro-multiselect>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Canais de Venda</label>
              <sgt-novo-canal-venda-multiselect [(ngModel)]="filter.idsCanaisVenda">
              </sgt-novo-canal-venda-multiselect>
            </div>
            <div class="form-group col-12" *ngIf="configEmpresa?.possuiLocalFaturamento">
              <label class="col-form-label">Locais de Faturamentos</label>
              <sgt-novo-local-faturamento-multiselect [(ngModel)]="filter.idsLocaisFaturamentos">
              </sgt-novo-local-faturamento-multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-bullhorn"></i> Campanhas
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Áreas</label>
              <sgt-novo-area-multiselect [(ngModel)]="filter.idsAreasCampanhas">
              </sgt-novo-area-multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-tag"></i> Tags
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <ng-container *ngIf="isShowSegmentosClientesFilter">
              <div class="form-group col-12">
                <label class="col-form-label">Tags de Cliente</label>
                <sgt-tags-multi-select
                  [(ngModel)]="filter.idsTagsClientes"
                  [cadastros]="tagCadastroCliente"
                  [situacoes]="tagSituacaoAtivo"
                  [settings]="{
                    placeholder: 'Selecione as tags',
                    searchEmptyResultMessage: 'Nenhuma tag encontrada',
                    plural: 'Tags de Cliente',
                    singular: 'Tag de Cliente',
                    showFooter: false
                  }"
                ></sgt-tags-multi-select>
              </div>
            </ng-container>
            <div class="form-group col-12">
              <label class="col-form-label">Tags de Item</label>
              <sgt-tags-multi-select
                #tagsItensMultiSelect
                [(ngModel)]="filter.idsTagsItens"
                [cadastros]="tagCadastroItem"
                [situacoes]="tagSituacaoAtivo"
                [settings]="{
                  placeholder: 'Selecione as tags',
                  searchEmptyResultMessage: 'Nenhuma tag encontrada',
                  plural: 'Tags de Item',
                  singular: 'Tag de Item',
                  showFooter: false
                }"
              ></sgt-tags-multi-select>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-cogs"></i> Operações
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Operações de Venda</label>
              <sgt-novo-operacao-venda-multiselect
                [(ngModel)]="filter.operacoesVenda">
              </sgt-novo-operacao-venda-multiselect>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Operações de Conta e Ordem</label>
              <sgt-novo-operacao-conta-ordem-multiselect [(ngModel)]="filter.operacoesContaOrdem">
              </sgt-novo-operacao-conta-ordem-multiselect>
            </div>
            <div class="form-group col-12" *ngIf="configEmpresa?.possuiClicheria">
              <label class="col-form-label">Status da Clicheria</label>
              <sgt-pedido-clicheria-status-multiselect
                [idsStatusClicheria]="filter.statusesClicheria"
                (idsStatusClicheriaChange)="filter.statusesClicheria = $event"
              ></sgt-pedido-clicheria-status-multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-credit-card"></i> Pagamento
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Tipos</label>
              <sgt-novo-condicao-pagamento-tipo-multiselect [(ngModel)]="filter.tiposPagamentos">
              </sgt-novo-condicao-pagamento-tipo-multiselect>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Formas</label>
              <sgt-novo-forma-pagamento-multiselect [(ngModel)]="filter.idsFormasPagamentos">
              </sgt-novo-forma-pagamento-multiselect>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Condições</label>
              <sgt-novo-condicao-pagamento-multiselect [(ngModel)]="filter.idsCondicoesPagamentos">
              </sgt-novo-condicao-pagamento-multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-tags"></i> Cupons de Desconto
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <sgt-tokenfield-input
                [ngModel]="cuponsDescontoTokens"
                (ngModelChange)="onCuponsDescontoChange($event)"
                [settings]="{ placeholder: 'Cupons de Desconto' }"
              ></sgt-tokenfield-input>
              <small class="text-muted">
                Ex: CUPOM10, FRETEGRATIS, CASHBACK20
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-map-marker-alt"></i> Localização
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Estados</label>
              <sgt-novo-estado-multiselect
                [(ngModel)]="filter.idsEstadosClientes">
              </sgt-novo-estado-multiselect>
            </div>
            <div class="form-group col-12">
              <label for="filterCidadeCliente" class="col-form-label">Cidade</label>
              <sgt-novo-typeahead-cidade
                [(ngModel)]="filter.cidadeCliente"
                id="filterCidadeCliente">
              </sgt-novo-typeahead-cidade>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div footer>
    <div class="filter-sidebar__footer">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="onClearFilter()"
      >
       <i class="fas fa-eraser"></i> Limpar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="applyFilterAndClose()"
      >
        <i class="fas fa-filter"></i> Aplicar Filtros
      </button>
    </div>
  </div>
</sgt-modal>
